import { createApp } from 'vue';
import keycloak from '@/core/helpers/keycloak.helper';
import App from './App.vue';
import router from '@/apps/admin/router';
import { plainTextPasteDirective } from '@/core/directives/plainTextPaste.directive';

export function initializeApp() {
   const app = createApp(App);

   app.use(router);
   app.use(keycloak);
   app.directive('plain-text-paste', plainTextPasteDirective);

   return app;
}
